export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';


export const CREATE_RULE_REQUEST = "CREATE_RULE_REQUEST";
export const CREATE_RULE_SUCCESS = "CREATE_RULE_SUCCESS";
export const CREATE_RULE_FAILURE = "CREATE_RULE_FAILURE";

export const FETCH_SUBSCRIPTIONS_REQUEST = 'FETCH_SUBSCRIPTIONS_REQUEST';
export const FETCH_SUBSCRIPTIONS_SUCCESS = 'FETCH_SUBSCRIPTIONS_SUCCESS';
export const FETCH_SUBSCRIPTIONS_FAILURE = 'FETCH_SUBSCRIPTIONS_FAILURE';

export const CREATE_SUBSCRIPTION_REQUEST = 'CREATE_SUBSCRIPTION_REQUEST';
export const CREATE_SUBSCRIPTION_SUCCESS = 'CREATE_SUBSCRIPTION_SUCCESS';
export const CREATE_SUBSCRIPTION_FAILURE = 'CREATE_SUBSCRIPTION_FAILURE';

export const DELETE_SUBSCRIPTION_REQUEST = 'DELETE_SUBSCRIPTION_REQUEST';
export const DELETE_SUBSCRIPTION_SUCCESS = 'DELETE_SUBSCRIPTION_SUCCESS';
export const DELETE_SUBSCRIPTION_FAILURE = 'DELETE_SUBSCRIPTION_FAILURE';

export const GET_TEAM_DETAILS_SUCCESS = 'GET_TEAM_DETAILS_SUCCESS';
export const DELETE_TEAM_SUCCESS = 'DELETE_TEAM_SUCCESS';



export const FETCH_RULE_REQUEST = 'FETCH_RULE_REQUEST';
export const FETCH_RULE_SUCCESS = 'FETCH_RULE_SUCCESS';
export const FETCH_RULE_FAILURE = 'FETCH_RULE_FAILURE';
export const UPDATE_RULE_REQUEST = 'UPDATE_RULE_REQUEST';
export const UPDATE_RULE_SUCCESS = 'UPDATE_RULE_SUCCESS';
export const UPDATE_RULE_FAILURE = 'UPDATE_RULE_FAILURE';

export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';

export const FETCH_USER_SUBSCRIPTIONS_REQUEST = 'FETCH_USER_SUBSCRIPTIONS_REQUEST';
export const FETCH_USER_SUBSCRIPTIONS_SUCCESS = 'FETCH_USER_SUBSCRIPTIONS_SUCCESS';
export const FETCH_USER_SUBSCRIPTIONS_FAILURE = 'FETCH_USER_SUBSCRIPTIONS_FAILURE';



export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';




